'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Collection_Icon = require('./Collection_Icon');

var _Collection_Icon2 = _interopRequireDefault(_Collection_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collection_Icon_Wrapper = function (_React$PureComponent) {
	_inherits(Collection_Icon_Wrapper, _React$PureComponent);

	function Collection_Icon_Wrapper() {
		_classCallCheck(this, Collection_Icon_Wrapper);

		return _possibleConstructorReturn(this, (Collection_Icon_Wrapper.__proto__ || Object.getPrototypeOf(Collection_Icon_Wrapper)).apply(this, arguments));
	}

	_createClass(Collection_Icon_Wrapper, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var checkSelected = function checkSelected(internal_id) {
				return _this2.props.selected.some(function (el) {
					return el.internal_id === internal_id;
				});
			};
			var checkLocked = function checkLocked(internal_id) {
				return _this2.props.selected.some(function (el) {
					return el.internal_id === internal_id && iconPressConfig.lock == 1 && el.user_id != iconPressConfig.user_id;
				});
			};

			return this.props.items.map(function (item) {

				var isSelected = checkSelected(item.internal_id);
				var isSelectedClass = isSelected ? 'is-selected' : '';
				isSelectedClass += isSelected && checkLocked(item.internal_id) ? ' is-locked' : '';

				return _react2.default.createElement(_Collection_Icon2.default, {
					key: item.internal_id,
					icon: item,
					className: isSelectedClass,
					toggleSelected: _this2.props.toggleSelected
				});
			});
		}
	}]);

	return Collection_Icon_Wrapper;
}(_react2.default.PureComponent);

exports.default = Collection_Icon_Wrapper;


//////////////////
// WEBPACK FOOTER
// ./src/components/Collection_Icon_Wrapper.js
// module id = 95
// module chunks = 0 1